import { useEffect, useState } from 'react';

/**
 * Hook to monitor Dynamic Yield (DY) core script and resource loading completion
 */
export const useDynamicYieldReady = () => {
  // 1. Define a state to store whether DY is ready
  const [dyIsReady, setDyIsReady] = useState(false);
  const [isFallback, setIsFallback] = useState(false);

  // 2. Use useEffect to register callback, ensuring it only executes once when component mounts
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const dyCallback = () => {
      console.log("DY.API('callback') executed: Dynamic Yield is ready.");
      setDyIsReady(true);
      clearTimeout(timeout);
    };

    // Define a function to attempt callback registration
    const tryRegisterCallback = () => {
      if (window.DY && window.DY.API) {
        window.DY.API('callback', dyCallback);
        return true; // Successfully registered
      }
      return false; // Not successfully registered
    };

    // 3. Attempt to register callback immediately
    if (!tryRegisterCallback()) {
      const pollInterval = setInterval(() => {
        if (tryRegisterCallback()) {
          clearInterval(pollInterval);
        }
      }, 1000);

      // Set timeout to stop polling after 15 seconds
      timeout = setTimeout(() => {
        clearInterval(pollInterval);
        console.error('DY.API object did not load within 15 seconds, please check Dynamic Yield integration code.');
        setIsFallback(true);
      }, 15000);

      return () => {
        clearInterval(pollInterval);
        clearTimeout(timeout);
      };
    }
  }, []);

  return { dyIsReady, isFallback };
};
